import type { Child, EsdmProgressDoc } from '@aba-denver/core';
import { calculateAge, calculateCorrectedAge, formatAge, ESDM_ITEMS, getEsdmDomainRollup } from '@aba-denver/core';

export function formatDate(iso: string | undefined | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('pt-BR');
}

/** Chronological (or corrected, for premature) age string for a patient. */
export function patientAgeLabel(child: Child): string {
  const age =
    child.isPremature && child.gestationalWeeks
      ? calculateCorrectedAge(child.birthDate, child.gestationalWeeks)
      : calculateAge(child.birthDate);
  return formatAge(age);
}

/** Human status of a patient's ESDM Curriculum Checklist progress. */
export function esdmStatus(progressDoc: EsdmProgressDoc | undefined): {
  label: string;
  variant: 'neutral' | 'success' | 'info';
  acquired: number;
  total: number;
} {
  const rollup = getEsdmDomainRollup(ESDM_ITEMS, progressDoc?.items ?? {});
  const acquired = rollup.reduce((sum, r) => sum + r.acquired, 0);
  const total = rollup.reduce((sum, r) => sum + r.total, 0);

  if (acquired === 0) return { label: 'Sem avaliação', variant: 'neutral', acquired, total };
  if (acquired >= total) return { label: 'Concluído', variant: 'success', acquired, total };
  return { label: 'Em andamento', variant: 'info', acquired, total };
}
